module.exports = __webpack_public_path__ + "media/images/flags/AZ-390a36a1ec2ca232f3202c8a9dee27be.svg";